import { useState } from 'react';
import { ReportModal } from '@/pages/GamAdvertisers/components/ReportModal';
import type { CacBasis, LLDay } from '@/types/lead-lifetime';
import { useMoney } from './currency';
import { BASIS_LABEL, cacKey, fmtLL } from './format';

const INITIAL_ROWS = 7;

function Table({ days, basis }: { days: LLDay[]; basis: CacBasis }) {
    const money = useMoney();
    return (
        <div className="overflow-x-auto">
            <table className="w-full text-xs">
                <thead>
                    <tr className="border-b border-border text-left text-[10px] uppercase tracking-wider text-muted-foreground">
                        <th className="px-3 py-2">Dia</th>
                        <th className="px-3 py-2 text-right">Gasto</th>
                        <th className="px-3 py-2 text-right">Leads</th>
                        <th className="px-3 py-2 text-right">Conversas</th>
                        <th className="px-3 py-2 text-right">CAC ({BASIS_LABEL[basis]})</th>
                        <th className="px-3 py-2 text-right">Receita</th>
                        <th className="px-3 py-2 text-right">Ativos</th>
                        <th className="px-3 py-2 text-right">ARPU</th>
                        <th className="px-3 py-2 text-right">Custo/usuário</th>
                    </tr>
                </thead>
                <tbody>
                    {days.map((d) => (
                        <tr key={d.date} className="border-b border-border/60 tabular-nums">
                            <td className="px-3 py-2 font-medium">
                                {fmtLL.date(d.date)}
                                {d.partial && <span className="ml-1 text-[10px] text-muted-foreground">(em andamento)</span>}
                            </td>
                            <td className="px-3 py-2 text-right">{money.fmt(d.spend)}</td>
                            <td className="px-3 py-2 text-right">{fmtLL.num(d.new_leads)}</td>
                            <td className="px-3 py-2 text-right">{fmtLL.num(d.conversations)}</td>
                            <td className="px-3 py-2 text-right">{money.unit(d[cacKey(basis)])}</td>
                            <td className="px-3 py-2 text-right">{money.fmt(d.revenue)}</td>
                            <td className="px-3 py-2 text-right">{fmtLL.num(d.active_leads)}</td>
                            <td className="px-3 py-2 text-right">{money.unit(d.arpu)}</td>
                            <td className="px-3 py-2 text-right">{money.unit(d.cost_per_user)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

/** Diário: últimos dias na tela, o período inteiro no modal. */
export function DailyTable({ days, basis }: { days: LLDay[]; basis: CacBasis }) {
    const [showAll, setShowAll] = useState(false);
    const ordered = [...days].reverse();
    return (
        <div className="rounded-lg border border-border bg-card">
            <div className="border-b border-border px-4 py-3">
                <p className="text-[11px] font-medium uppercase tracking-[0.12em] text-muted-foreground">Dia a dia</p>
                <p className="mt-0.5 text-[11px] text-muted-foreground/80">Leads = entraram no dia · Ativos = clicaram no dia (qualquer idade)</p>
            </div>
            <Table days={ordered.slice(0, INITIAL_ROWS)} basis={basis} />
            {ordered.length > INITIAL_ROWS && (
                <div className="px-4 py-2 text-center">
                    <button type="button" onClick={() => setShowAll(true)} className="rounded-md border border-border px-3 py-1 text-xs text-muted-foreground hover:bg-accent hover:text-foreground">
                        Ver todos os dias ({ordered.length})
                    </button>
                </div>
            )}
            <ReportModal open={showAll} onClose={() => setShowAll(false)} title="Dia a dia" subtitle={`${ordered.length} dias · valores líquidos em R$`}>
                <Table days={ordered} basis={basis} />
            </ReportModal>
        </div>
    );
}
